import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECleaningScoreActionTypes {
  SetRating = 'NEW_REVIEW/CLEANING/SET',
}

type TSetCleaningScore = ITypedReduxAction<ECleaningScoreActionTypes.SetRating, number>;

export const setCleaningScore: (rating: number) => TSetCleaningScore = actionGenerator<
  ECleaningScoreActionTypes.SetRating,
  number
>(ECleaningScoreActionTypes.SetRating);

export type TCleaningScore = TSetCleaningScore;
